import { Stack } from "@mui/material";
import { Sparkles } from "lucide-react";
import type { FC } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { Callout } from "web_myplann/Shared/Components/Callout";

const R = Resources.Inspiration.OwnHome.Result;

type Props = {
	onClick: () => void;
};

export const ExpensesNudge: FC<Props> = ({ onClick }) => {
	const { t } = useResource();

	return (
		<Stack px={1.6}>
			<Callout
				color="blue"
				icon={Sparkles}
				title={t(R.nudgeExpensesTitle)}
				description={t(R.nudgeExpensesText)}
				onClick={onClick}
			/>
		</Stack>
	);
};
